import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { IcClose24Icon, IcDoneIcon } from '@gem/icons';
import { AvatarTypes, IconButton, IconViewSizes } from '@gem/ui-kit';

import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';

import { useAccessRequestItemPresenter } from './AccessRequestItem.presenter';
import styles from './AccessRequestItem.styles.m.css';
import { IAccessRequestItemProps } from './AccessRequestItem.types';

export const AccessRequestItem: FC<IAccessRequestItemProps> = observer((props) => {
  const presenter = useAccessRequestItemPresenter(props);

  return (
    <div className={styles.container}>
      <PopupInfoCard
        className={styles.card}
        type={AvatarTypes.Round_10}
        avatarTitle={presenter.user?.avatarTitle}
        avatarUrl={presenter.user?.avatarUrl || ''}
        avatarBackgroundColorIndex={presenter.user?.avatarColorIndex}
        title={presenter.user?.displayName || ''}
        subtitle={
          props.request.deviceName
            ? `${props.request.deviceName} · ${presenter.deviceOS}`
            : presenter.deviceOS
        }
      />
      <div>
        <IconButton
          Icon={IcClose24Icon}
          onClick={(): void => {
            props.onBlock(props.request.deviceId, props.request.userId);
          }}
          theme="2"
          iconSize={IconViewSizes.Medium}
          size={IconViewSizes.Small}
          className={styles.icon}
          isDisabled={props.isLoading}
        />
        <IconButton
          Icon={IcDoneIcon}
          onClick={(): void => {
            props.onApprove(props.request.deviceId, props.request.userId);
          }}
          theme="2"
          iconSize={IconViewSizes.Medium}
          size={IconViewSizes.Small}
          className={styles.icon}
          isDisabled={props.isLoading}
        />
      </div>
    </div>
  );
});
